/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { memo, useState, useEffect, useCallback } from 'react';
import Button from '@wconcept/wconcept-ui-renewal/src/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { IconArrowDown03 } from '@wconcept/wconcept-ui-renewal/src/components/atoms/svg';
import AccordionPanel from './AccordionPanel';
import { AccordionWrap } from './AccordionStyles';

interface IProps {
  id?: string;
  children: React.ReactNode;
  selectedValue?: string;
  className?: string;
  isToggle?: boolean;
  buttonText?: string;
  onChange?: (value: string) => void;
  onClickMore?: () => void;
  extra?: React.ReactNode;
  lazyPanel?: boolean;
}

const Accordion = ({
  id,
  selectedValue,
  className,
  children,
  isToggle = true,
  onChange,
  lazyPanel = false,
}: IProps) => {
  const [$selectedValue, setSelectedValue] = useState(selectedValue);

  useEffect(() => {
    setSelectedValue(selectedValue);
  }, [selectedValue]);

  const param = {
    className: classNameBind(['accordion-base', className || '']),
  };

  // EVENT HANDLER : onClickLabel
  const onClickLabel = useCallback(
    (e: any) => {
      const ariaControls = e.target?.getAttribute('aria-controls');
      if ($selectedValue !== ariaControls) {
        setSelectedValue(ariaControls ?? '');
        if (typeof onChange === 'function') onChange(ariaControls ?? '');
      } else if ($selectedValue === ariaControls && isToggle) {
        setSelectedValue('');
        if (typeof onChange === 'function') onChange('');
      }
    },
    [$selectedValue, isToggle, onChange]
  );

  // ITEM RENDERER : getLabel
  const getLabel = useCallback(
    (children: React.ReactNode) => {
      // 배열이 아닌 경우 배열로 변환
      const childrenArray = Array.isArray(children) ? children : [children];

      return childrenArray?.map((v: React.ReactElement, i: number) => {
        // v가 없거나 props가 없으면 건너뛰기
        if (!v || !v.props) return null;

        const { value, label, children, extra } = v.props as {
          value: string;
          label: string;
          children: React.ReactNode;
          extra: React.ReactNode;
        };

        return (
          <div
            className={`accordion-item ${
              value === $selectedValue ? 'active' : ''
            }`}
            key={i}
          >
            <div className="accordion-label">
              <Button
                role="button"
                className="label"
                onClick={onClickLabel}
                ariaControls={value}
                ariaExpanded={value === $selectedValue}
                icon={<IconArrowDown03 className="arrow" />}
              >
                {label}
              </Button>

              {extra && value === $selectedValue ? extra : null}
            </div>
            <AccordionPanel
              id={value}
              className="accordion-panel"
              ariaLabelledby={`acd-${value}`}
              hidden={value !== $selectedValue}
            >
              {lazyPanel && value !== $selectedValue ? null : children}
            </AccordionPanel>
          </div>
        );
      });
    },
    [$selectedValue, onClickLabel, lazyPanel]
  );

  return <AccordionWrap {...param}>{getLabel(children)}</AccordionWrap>;
};

export default memo(Accordion);
